import { VideoPlayerManager } from 'utils/video-player-manager'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import {getRegionList} from '@/api/get-data.js'

export default {
  name: 'MinLiveVideo',
  data() {
    return {
      // 视频播放器管理器
      tileVisible: true,
      playProtocol: 2, // 播放协议，0-rtmp,1-hls,2-http-flv,3-ws-flv
      playerManager: null,
      scheme: 'none'
    }
  },
  mixins: [
    ssoLoginMixin,
    convertorMixin
  ],
  computed: {
    players: function () {
      return this.playerManager.players
    },
    currentVideoPlayerId: function () {
      return this.playerManager.currentPlayerId
    },
    currentStreamNodeId: function () {
      return this.playerManager.currentStreamNodeId
    },
    isSingle: function () {
      return this.playerManager.isSingle()
    }
  },
  created() {
    // 自动播放方案
    this.scheme = this.$globalConfig.scheme
    if (this.$route.query.scheme) {
      this.scheme = this.$route.query.scheme
    }

    // 创建播放器管理器
    this.playerManager = new VideoPlayerManager()
  },
  mounted() {
    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      // 获取区域列表
      this.getRegionList2()
    })
  },
  methods: {
    // 查询区域列表
    getRegionList2() {
      getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
        // 自动打开视频
        if (this.$store.getters.userToken !== '') {
          // 自动播放方案
          // scheme=none
          // scheme=histroyVideo
          // scheme=region&regionId=1&regionCode=abcd&maxNode=4
          // scheme=userCollection&collectionId=1
          // scheme=scene&sceneId=1&sceneCode=abcd
          // scheme=nodeSet&nodeIds=1-2-3-4-5
          if (this.scheme === '' || this.scheme === 'none') {
          } else if (this.scheme === 'histroyVideo') {
            this.startHistoryVideos()
          } else if (this.scheme === 'region') {
            this.startVideosByRegionIdOrCode(this.$route.query.regionId, this.$route.query.regionCode)
          } else if (this.scheme === 'scene') {
            this.startVideosBySceneIdOrCode(this.$route.query.sceneId, this.$route.query.sceneCode)
          } else if (this.scheme === 'userCollection') {
            this.startVideosByUserCollectionId(this.$route.query.collectionId)
          } else if (this.scheme === 'nodeSet') {
          } else {
          }
        }
      })
    },
    // 打开视频
    startVideo(id, name, streamOpenMode, streamServerIp, streamServerPort) {
      if (this.playerManager.getInactiveVideoPlayerCount() === 0) {
        this.$messagebox.confirm('没有可用的视频窗口，请先关闭窗口后再尝试', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
        return false
      }
      this.playerManager.openVideoPlayer(id, name, streamOpenMode, false, this.$store.getters.userToken, this.playProtocol, streamServerIp, streamServerPort)
      // 记录视频节点数组
      // this.$store.commit('liveVideo/SET_ACTIVE_STREAM_NODES', this.playerManager.streamNodes)
      return true
    },
    // 打开多个视频
    startVideos(streamNodes) {
      let layout = { name: '单画面', count: 1 }
      if (streamNodes.length > 1) {
        layout = { name: '四画面', count: 4 }
      }
      this.playerManager.switchLayout(layout)

      // 调阅实时视频
      let streamNodes2 = []
      for (let i = 0; i < streamNodes.length; ++i) {
        if (!streamNodes[i]) {
          continue
        }
        streamNodes[i].audioEnabled = false
        streamNodes[i].accessToken = this.$store.getters.userToken
        streamNodes[i].playProtocol = this.playProtocol
        streamNodes2.push(streamNodes[i])
      }
      this.playerManager.openVideoPlayers(streamNodes2)
    },
    // 打开上一次的打开视频
    startHistoryVideos() {
      this.startVideos(this.$store.getters.liveVideoActiveStreamNodes)
    },
    // 根据区域id或code打开视频
    startVideosByRegionIdOrCode(id, code) {
      if (id != null) {
        this.$http(this.$api.streamNodeList, {
          regionId: id,
          streamServerInfoRequired: 1, // 需获取流媒体服务信息
          pageNum: 1,
          pageSize: 16
        }).then(
          res => {
            if (res.code === 200) {
              if (res.data.length) {
                this.startVideos(res.data)
              }
            }
          }
        )
      } else if (code != null) {
        this.$http(this.$api.streamNodeList, {
          regionId: 0,
          regionCode: code,
          streamServerInfoRequired: 1, // 需获取流媒体服务信息
          pageNum: 1,
          pageSize: 16
        }).then(
          res => {
            if (res.code === 200) {
              if (res.data.length) {
                this.startVideos(res.data)
              }
            }
          }
        )
      }
    },
    // 根据场景id或code打开视频
    startVideosBySceneIdOrCode(id, code) {
      if (id != null) {
        this.$http(this.$api.sceneStreamNodeList, {
          sceneId: id,
          streamServerInfoRequired: 1, // 需获取流媒体服务信息
          pageNum: 1,
          pageSize: 16
        }).then(
          res => {
            if (res.code === 200) {
              if (res.data.length) {
                this.startVideos(res.data)
              }
            }
          }
        )
      } else if (code != null) {
        this.$http(this.$api.sceneStreamNodeList, {
          sceneId: 0,
          sceneCode: code,
          streamServerInfoRequired: 1, // 需获取流媒体服务信息
          pageNum: 1,
          pageSize: 16
        }).then(
          res => {
            if (res.code === 200) {
              if (res.data.length) {
                this.startVideos(res.data)
              }
            }
          }
        )
      }
    },
    // 根据用户收藏id打开视频
    startVideosByUserCollectionId(id) {
      if (id != null) {
        this.$http(this.$api.userCollectionStreamNodeList, {
          userCollectionId: id,
          streamServerInfoRequired: 1, // 需获取流媒体服务信息
          pageNum: 1,
          pageSize: 16
        }).then(
          res => {
            if (res.code === 200) {
              if (res.data.length) {
                this.startVideos(res.data)
              }
            }
          }
        )
      }
    },
    // 选中视频播放器
    selectVideoPlayer(videoPlayer) {
      this.playerManager.select(videoPlayer)
      // 选中视频树节点
      this.$refs.tree.setCurrentKey('streamNode' + videoPlayer.streamNodeId)
      this.handleTreeNodeClick(this.$refs.tree.getCurrentNode())
    },
    // 选中视频播放器
    selectVideoPlayerByStreamNodeId(streamNodeId) {
      this.playerManager.selectByStreamNodeId(streamNodeId)
    },
    // 单画面
    singleLayout() {
      // 暂停播放
      for (let i = 0; i < this.playerManager.players.length; ++i) {
        if (this.playerManager.players[i].active && this.playerManager.currentPlayerId !== this.playerManager.players[i].id) {
          this.playerManager.players[i].pausePlay()
        }
      }
      this.playerManager.switchLayout({ name: '单画面', count: 1 })
      // this.$store.commit('liveVideo/SET_LAYOUT', this.playerManager.currentLayout) // 记录布局
    },
    // 四画面
    fourLayout() {
      this.playerManager.switchLayout({ name: '四画面', count: 4 })
      // 恢复播放
      for (let i = 0; i < this.playerManager.players.length; ++i) {
        if (this.playerManager.players[i].paused) {
          this.playerManager.players[i].resumePlay()
        }
      }
      // this.$store.commit('liveVideo/SET_LAYOUT', this.playerManager.currentLayout) // 记录布局
    },
    // 抓图
    capturePictureJpeg() {
      if (this.playerManager.currentPlayer === null) {
        this.$messagebox.confirm('请先打开当前选中摄像机视频！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
      } else {
        let params = {
          accessToken: this.$store.getters.userToken,
          nodeId: this.playerManager.currentStreamNodeId,
          streamOpenMode: Number(this.playerManager.currentPlayer.streamOpenMode),
          pictureFormat: 1
        }
        this.$http(this.$api.capturePicture, params).then(
          res => {
            if (res.code === 200) {
              window.open(res.data.pictureUrl)
            }
          }
        )
      }
    },
    // 关闭指定视频
    stopVideo(streamNodeId) {
      this.playerManager.closeVideoPlayer(streamNodeId)
      // 记录视频节点数组
      // this.$store.commit('liveVideo/SET_ACTIVE_STREAM_NODES', this.playerManager.streamNodes)
    },
    // 关闭全部视频
    stopAllVideo() {
      this.playerManager.closeAll()
      // 记录视频节点数组
      // this.$store.commit('liveVideo/SET_ACTIVE_STREAM_NODES', this.playerManager.streamNodes)
    },
    // 是否显示标题
    switchTitleVisible() {
      this.tileVisible = !this.tileVisible
      for (let i = 0; i < this.playerManager.players.length; ++i) {
        if (this.tileVisible) {
          this.$refs.videoPlayerContainer[i].style.height = 'calc(100% - 33px)'
          this.$refs.videoPlayerContainer[i].style.marginTop = '0'
        } else {
          this.$refs.videoPlayerContainer[i].style.height = 'calc(100% - 10px)'
          this.$refs.videoPlayerContainer[i].style.marginTop = '5px'
        }
      }
    },
    // 全屏
    fullScreen() {
      this.treeSideBarOpen = false
      this.footerOpen = false
      if (this.tileVisible) {
        this.switchTitleVisible()
      }
    },
    // 恢复正常
    retsoreNormal() {
      this.treeSideBarOpen = true
      this.footerOpen = true
      if (!this.tileVisible) {
        this.switchTitleVisible()
      }
    },
    // 云台控制
    ptzControl(ptzCmd) {
      if (this.playerManager.currentPlayer === null) {
        this.$messagebox.confirm('请先打开当前选中摄像机视频！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
      } else {
        let params = {
          accessToken: this.$store.getters.userToken,
          nodeId: this.playerManager.currentStreamNodeId,
          ptzCmd: ptzCmd,
          hSpeed: this.hSpeed,
          vSpeed: this.vSpeed
        }
        this.$http(this.$api.ptzControl, params).then(
          res => {
            if (res.code === 200) {
              console.log(res.data)
            }
          }
        )
      }
    },
    // 预置点控制
    presetControl(presetCmd) {
      if (this.playerManager.currentPlayer === null) {
        this.$messagebox.confirm('请先打开当前选中摄像机视频！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
      } else {
        if (this.presetInfoTableData.length === 0) return

        let params = {
          nodeId: this.playerManager.currentStreamNodeId,
          presetCmd: presetCmd,
          presetId: 0,
          presetNum: this.persetInfoTableCurrentPresetNum
        }
        this.$http(this.$api.presetControl, params).then(
          res => {
            if (res.code === 200) {
              console.log(res.data)
            }
          }
        )
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/monitoring/minLiveVideo/MinLiveVideo.js